(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('LevelSearch', LevelSearch);

    LevelSearch.$inject = ['$resource'];

    function LevelSearch($resource) {
        var resourceUrl =  'api/_search/levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
